export default {
  // list
  'job.query.jobName': 'Job Name',
  'job.query.jobName.placeholder': 'Please enter job name',
  'job.query.env': 'Env',
  'job.query.env.placeholder': 'Please enter env',
  'job.column.jobName': 'Job Name',
  'job.column.jobGroup': 'Job Group',
  'job.column.env': 'Env',
  'job.column.cron': 'Cron',
  'job.column.invokeClassName': 'Class',
  'job.column.methodName': 'Method',
  'job.column.status': 'Status',
  'job.column.operation.exec': 'Exec',
  'job.column.operation.log': 'Log',
  'job.message.delete.batch.confirm': 'Confirm to delete the selected {length} records?',
  'job.message.delete.confirm': 'Confirm to delete "{jobName}"?',
  'job.message.exec.confirm': 'Confirm to execute immediately?',
  'job.message.status.confirm': 'Confirm to {status}"{jobName}"?',
  'job.message.exec.success': 'Exec success',
  // edit
  'job.edit.title': 'Edit Job',
  'job.add.title': 'Add Job',
  'job.edit.success': 'Edit success',
  'job.add.success': 'Add success',
  'job.edit.form.jobName': 'Job Name',
  'job.edit.form.jobName.placeholder': 'Please enter job name',
  'job.edit.form.jobName.required': 'Please enter job name',
  'job.edit.form.jobGroup': 'Job Group',
  'job.edit.form.jobGroup.placeholder': 'Please enter job group',
  'job.edit.form.jobGroup.required': 'Please enter job group',
  'job.edit.form.env': 'Env',
  'job.edit.form.env.placeholder': 'Please enter env',
  'job.edit.form.cron': 'Cron',
  'job.edit.form.cron.placeholder': 'Please enter cron',
  'job.edit.form.cron.required': 'Please enter cron',
  'job.edit.form.status': 'Status',
  'job.edit.form.status.placeholder': 'Please select status',
  'job.edit.form.status.required': 'Please select status',
  'job.edit.form.status.normal': 'Normal',
  'job.edit.form.status.stopped': 'Stopped',
  'job.edit.form.invokeMode': 'Invoke Mode',
  'job.edit.form.invokeMode.placeholder': 'Please select invoke mode',
  'job.edit.form.invokeMode.required': 'Please select invoke mode',
  'job.edit.form.springBeanName': 'SpringBean',
  'job.edit.form.springBeanName.placeholder': 'Please enter spring bean name',
  'job.edit.form.springBeanName.required': 'Please enter spring bean name',
  'job.edit.form.invokeClassName': 'Class',
  'job.edit.form.invokeClassName.placeholder': 'Please enter class name',
  'job.edit.form.invokeClassName.required': 'Please enter class name',
  'job.edit.form.methodName': 'Method',
  'job.edit.form.methodName.placeholder': 'Please enter method name',
  'job.edit.form.methodName.required': 'Please enter method name',
  'job.edit.form.methodParams': 'Method Params',
  'job.edit.form.methodParams.placeholder': 'Please enter method params',
  'job.edit.form.misfirePolicy': 'Misfire Policy',
  'job.edit.form.misfirePolicy.placeholder': 'Please select misfire policy',
  'job.edit.form.misfirePolicy.required': 'Please select misfire policy',
  'job.edit.form.misfirePolicy.default': 'Default',
  'job.edit.form.misfirePolicy.fireNow': 'Fire Now',
  'job.edit.form.misfirePolicy.fireOnce': 'Fire Once',
  'job.edit.form.misfirePolicy.ignore': 'Ignore',
  'job.edit.form.alarmEmail': 'Alarm Email',
  'job.edit.form.alarmEmail.placeholder': 'Please enter alarm email',
  'job.edit.form.concurrent': 'Concurrent',
  'job.edit.form.concurrent.placeholder': 'Please select concurrent',
  'job.edit.form.concurrent.required': 'Please select concurrent',
  'job.edit.form.pauseAfterFailure': 'Pause After Failure',
  'job.edit.form.pauseAfterFailure.placeholder': 'Please select pause after failure',
  'job.edit.form.pauseAfterFailure.required': 'Please select pause after failure',
  // log
  'job.log.title': 'Job Log',
  'job.log.query.execTime': 'Exec Time',
  'job.log.query.startTime.placeholder': 'Select start time',
  'job.log.query.endTime.placeholder': 'Select end time',
  'job.log.column.jobName': 'Job Name',
  'job.log.column.invokeClassName': 'Class',
  'job.log.column.methodName': 'Method',
  'job.log.column.success': 'Success',
  'job.log.column.success.true': 'Success',
  'job.log.column.success.false': 'Failure',
  'job.log.column.startTime': 'Start Time',
  'job.log.column.execTime': 'Exec Time',
  'job.log.column.endTime': 'End Time',
  'job.log.message.delete.confirm': 'Confirm to delete "{id}"?',
  'job.log.pickerOptions.shortcuts.today': 'Today',
  'job.log.pickerOptions.shortcuts.yesterday': 'Yesterday',
  'job.log.pickerOptions.shortcuts.lastWeek': 'Last Week',
}
